import { render } from "./PostCards.vue?vue&type=template&id=254f4ab4&scoped=true"
import script from "./PostCards.vue?vue&type=script&lang=js"
export * from "./PostCards.vue?vue&type=script&lang=js"

import "./PostCards.vue?vue&type=style&index=0&id=254f4ab4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254f4ab4"]])

export default __exports__